/**
 * PosWebPrintBanner — Aviso final del panel POS con las vías disponibles para
 * imprimir desde el navegador (relay local / WebUSB) y enlaces a la guía.
 *
 * QUÉ EXPORTA: PosWebPrintBanner (named).
 */

import {
  AlertTriangle,
  Monitor,
  Network,
  Smartphone,
  Video,
} from "lucide-react";
import { POS_WEB_PRINT_GUIDE_URL } from "../utils/userSettingsPosHardware.helpers";

export function PosWebPrintBanner() {
  return (
    <div className="rounded-xl border-2 border-amber-200 dark:border-amber-800/60 bg-amber-50/80 dark:bg-amber-950/30 p-3 space-y-2">
      <div className="flex items-center gap-2">
        <AlertTriangle
          size={16}
          className="text-amber-600 dark:text-amber-400 shrink-0"
        />
        <p className="text-xs font-black text-amber-900 dark:text-amber-100">
          Impresión en el navegador web
        </p>
      </div>
      <p className="text-[10px] text-amber-800 dark:text-amber-200 leading-relaxed">
        Los navegadores no abren conexiones TCP ni Bluetooth directas. En web
        pura la térmica imprime por <strong>relay local (Wi-Fi)</strong> (pega
        la URL abajo, en «Dirección de red») o por <strong>WebUSB</strong>{" "}
        (Chrome/Edge con HTTPS). Sin esas vías, la impresión automática de
        pedidos queda en cola y se reanuda sola al configurarlas. La{" "}
        <strong>APK Android</strong> y la{" "}
        <strong>app de escritorio Windows</strong> soportan Wi-Fi, USB y
        Bluetooth directo.
      </p>
      <div className="flex items-center gap-2 pt-1">
        <div className="flex items-center gap-1.5 px-2 py-1 rounded-lg bg-green-100 dark:bg-green-900/40 text-[9px] font-bold text-green-800 dark:text-green-200">
          <Smartphone size={10} />
          APK Android
        </div>
        <div className="flex items-center gap-1.5 px-2 py-1 rounded-lg bg-blue-100 dark:bg-blue-900/40 text-[9px] font-bold text-blue-800 dark:text-blue-200">
          <Monitor size={10} />
          Escritorio Windows
        </div>
        <div className="flex items-center gap-1.5 px-2 py-1 rounded-lg bg-purple-100 dark:bg-purple-900/40 text-[9px] font-bold text-purple-800 dark:text-purple-200">
          <Network size={10} />
          Web (relay / WebUSB)
        </div>
      </div>
      <a
        href={POS_WEB_PRINT_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg bg-amber-100 dark:bg-amber-900/50 text-amber-900 dark:text-amber-100 text-[10px] font-black uppercase tracking-wide hover:bg-amber-200 dark:hover:bg-amber-800/60 transition-colors"
      >
        <Video size={12} />
        Ver guía con video
      </a>
    </div>
  );
}
